const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        metrics: {
          filterDate: "Filtrar por día",
          sales: {
            title: "Ventas",
            subtitle: "{{count}} purchase(s) enviado(s) al pixel",
          },
          clicks: {
            title: "Clics en el enlace",
            subtitle: "Accesos al contador en el día seleccionado",
          },
          conversations: {
            title: "Conversaciones iniciadas",
            subtitle: "Contactos identificados en Whaticket en el día",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          counterPhone: "Número contador",
          autoDisableCounter: "Desactivación automática",
        },
        autoDisable: {
          active: "Activa",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          counterPhone: "Número del contador",
          autoDisableCounter: "Desactivación automática",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          pixel: "Pixel",
          counterNumbers: "Números",
          leadMessages: "Registro de Mensajes",
          queues: "Linhas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          proxy: "Proxy",
        },
        appBar: {
          autoAttend: "Atención automática con IA",
          translation: "Traducción en tiempo real (apagar para no gastar API)",
          translationNeedsKey:
            "Configure la clave Google Translation en Ajustes para activar",
          translationEnabled: "Traducción automática",
          agentLanguage: "Idioma principal (panel)",
          outputLanguage: "Idioma de salida (mensajes enviados)",
          translationPrivacyNote:
            "Google Cloud Translation API. Active la API en Google Cloud Console.",
          translationApiKey: "Clave API Google Translation",
          translationApiKeyHelp:
            "Opcional si ya tiene clave Gemini en ajustes de IA. Guarda sin validar Cloud Translation.",
          translationSaveApiKey: "Guardar clave",
          translationKeySaved: "Clave guardada con éxito",
          translationKeyConfigured: "Clave Cloud Translation configurada",
          translationUsesGemini: "Usando clave Gemini de ajustes de IA",
          translationKeyMissing: "Sin clave Cloud — usa Gemini de IA si existe",
          translationApiKeyEmpty: "Pegue la clave antes de guardar",
          translationApiKeyReplace: "Pegue una nueva clave para reemplazar",
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          aiAssistant: {
            title: "Asistente IA",
            privacyNote:
              "Las conversaciones se envían al proveedor de IA configurado (Gemini o Anthropic). Configure las claves abajo.",
            provider: "Proveedor activo",
            geminiSection: "Google Gemini",
            anthropicSection: "Anthropic (Claude Sonnet)",
            model: "Modelo Gemini",
            anthropicModel: "Modelo Claude",
            apiKey: "Clave API Gemini",
            anthropicApiKey: "Clave API Anthropic",
            saveApiKey: "Guardar clave Gemini",
            saveAnthropicApiKey: "Guardar clave Anthropic",
            postSalePromptTitle: "Prompt posventa (botón IA en chat)",
            prompt: "Prompt posventa",
            promptHelp:
              "Placeholders: {nome}, {telefone}, {valor_venda}, {utm_campaign}",
            savePrompt: "Guardar prompt posventa",
            atendimentoPromptTitle: "Prompt atención (auto-aceptar conversaciones)",
            atendimentoPromptHelp:
              "Usado cuando la atención automática está activada arriba. Separado del posventa.",
            atendimentoPrompt: "Prompt atención",
            saveAtendimentoPrompt: "Guardar prompt atención",
            autoAttendNewContactsOnly: "IA automática solo para contactos nuevos",
            autoAttendNewContactsOnlyHelp:
              "Cuando está activo, la atención automática con IA solo inicia para contactos que nunca recibieron respuesta humana. Quienes ya fueron atendidos por un agente esperan atención humana.",
            autoAttendNewContactsOnlyOptions: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
            maxReplies: "Máx. respuestas por hora (por ticket)",
            historyMessages: "Mensajes de historial en contexto (recomendado: 40+)",
            replyDelayMin: "Retraso mínimo (segundos)",
            replyDelayMax: "Retraso máximo (segundos)",
            replyDelayHelp:
              "La IA espera un tiempo aleatorio entre mínimo y máximo antes de responder. Si máximo = 0 o igual al mínimo, usa el mínimo fijo.",
          },
          translation: {
            title: "Traducción en tiempo real",
            privacyNote:
              "Usa Google Cloud Translation API. Active la API en Google Cloud Console (separada de Gemini).",
            enabled: "Traducción activa",
            agentLanguage: "Idioma del agente (lee y escribe en el panel)",
            apiKey: "Clave API Google Translation",
            apiKeyHelp:
              "Puede usar la misma cuenta Google que Gemini, pero debe activar Cloud Translation API.",
            saveApiKey: "Guardar clave de traducción",
            options: {
              enabled: "Activada",
              disabled: "Desactivada",
            },
          },
        },
      },
      messagesList: {
        aiBadge: "IA",
        translationLabel: "Traducción",
        sentTranslationLabel: "Enviado",
        translateButton: "Traducir",
        translating: "Traduciendo...",
        header: {
          assignedTo: "Asignado a:",
          aiActive: "IA activa",
          aiModeSdr: "SDR",
          aiModePostSale: "Posventa",
          aiDisable: "Desactivar IA",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            pixel: "Pixel",
            ai: "IA",
            aiOn: "IA activada",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        translationPreview: "Se enviará en {{language}}: {{text}}",
        translationAgentPreview: "Traducción al {{language}}: {{text}}",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        customerLanguage: "Idioma del cliente",
        customerLanguageAuto: "Detectar automáticamente",
        pixelCreative: "Creativo (Pixel)",
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_TRANSLATION_FAILED:
          "No se pudo traducir el mensaje. Verifique la clave y Cloud Translation API en Google Cloud.",
        ERR_TRANSLATION_API_BLOCKED:
          "Cloud Translation API bloqueada. Actívela en console.cloud.google.com/apis/library/translate.googleapis.com y revise restricciones de la clave.",
        ERR_TRANSLATION_INVALID_KEY:
          "Clave Google Translation inválida. Genere una nueva en Google Cloud Console.",
        ERR_TRANSLATION_KEY_TEST_FAILED:
          "No se pudo validar la clave Google Translation. Intente de nuevo.",
        ERR_TRANSLATION_API_KEY_EMPTY: "Ingrese la clave Google Translation.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_PIXEL_INVALID_VALUE: "Ingrese un valor de venta válido.",
        ERR_PIXEL_LEAD_NOT_FOUND: "Lead del pixel no encontrado para este contacto.",
        ERR_PIXEL_ALREADY_CONVERTED: "Esta conversión ya fue enviada al pixel.",
        ERR_PIXEL_PHONE_NOT_FOUND: "Teléfono del contacto no encontrado.",
        ERR_PIXEL_SEND_FAILED: "Error al enviar conversión al pixel.",
        ERR_COUNTER_NUMBERS_LIST: "Error al listar números del contador.",
        ERR_COUNTER_NUMBER_ADD: "Error al agregar número.",
        ERR_COUNTER_NUMBER_TOGGLE: "Error al cambiar estado del número.",
        ERR_COUNTER_NUMBER_UPDATE: "Error al actualizar número.",
        ERR_COUNTER_NUMBER_DELETE: "Error al eliminar número.",
        ERR_LEAD_MESSAGES_LIST: "Error al listar mensajes recientes.",
      },
      leadMessages: {
        title: "Registro de Mensajes",
        section: {
          title: "Últimos Mensajes Recibidos",
          subtitle:
            "Leads recientes — mensaje, número WPP destino, campaña y estado",
        },
        stats: {
          total: "Total de leads",
          today: "Leads hoy",
          converted: "Convertidos",
        },
        table: {
          date: "Fecha/Hora",
          message: "Mensaje",
          destination: "Nº WPP Destino",
          campaign: "Campaña",
          status: "Estado",
        },
        status: {
          pending: "Pendiente",
          converted: "Vendido · €{{value}}",
        },
        empty: "Aún no hay mensajes recibidos.",
      },
      proxy: {
        title: "Proxy WhatsApp",
        formatHint:
          "Pegue en formato host:puerto:usuario:contraseña — tipo por defecto HTTP (opcional: socks5 o socks4 al final)",
        status: {
          enabled: "Proxy activo",
          disabled: "Proxy desactivado",
        },
        source: {
          settings: "Origen: panel",
          env: "Origen: .env",
          none: "Sin proxy configurado",
        },
        fields: {
          enabled: "Usar proxy en WhatsApp",
          rawLine: "Proxy completo",
          parsedTitle: "Campos reconocidos automáticamente",
          host: "Host",
          port: "Puerto",
          username: "Usuario",
          password: "Contraseña",
          passwordKeep: "Deje en blanco para mantener la contraseña actual",
          type: "Tipo",
        },
        buttons: {
          save: "Guardar proxy",
          check: "Probar proxy",
          reload: "Recargar",
        },
        check: {
          ok: "Proxy funcionando",
          fail: "Fallo en la prueba del proxy",
          latency: "Latencia: {{ms}} ms",
          ip: "IP externa: {{ip}}",
        },
        toasts: {
          saved: "¡Proxy guardado con éxito!",
          checkOk: "¡Proxy probado con éxito!",
          checkFail: "El proxy no respondió",
        },
        note:
          "Después de cambiar el proxy, desconecte y reconecte la sesión de WhatsApp en Conexiones para aplicar el cambio.",
      },
      counterNumbers: {
        title: "Números del Contador",
        stats: {
          daily: "Clics del día",
          total: "Clics totales",
          active: "Canales activos",
        },
        form: {
          addTitle: "Agregar nuevo canal",
          name: "Nombre",
          namePlaceholder: "ej: WPP Principal",
          phone: "Teléfono",
          message: "Mensaje predeterminado (opcional)",
          add: "Agregar",
          save: "Guardar",
          cancel: "Cancelar",
          phoneRequired: "Informe el teléfono.",
        },
        table: {
          active: "Activo",
          name: "Canal",
          daily: "Clics (día)",
          total: "Clics (total)",
          rotation: "Rotación",
          actions: "Acciones",
        },
        rotation: {
          next: "Siguiente",
          last: "Último",
          queued: "En cola",
          inactive: "Inactivo",
        },
        edit: {
          title: "Editar canal",
        },
        confirmDelete: {
          title: "Eliminar número",
          message: "¿Está seguro? El número será eliminado del contador de clics.",
        },
        toasts: {
          added: "¡Número agregado con éxito!",
          updated: "¡Número actualizado!",
          deleted: "¡Número eliminado!",
        },
      },
      pixel: {
        title: "Pixel",
        creative: "Creativo",
        adLabel: "Anuncio",
        adId: "Ad ID",
        adNotFound: "Anuncio no identificado",
        campaignLabel: "Campaña",
        campaignNotFound: "Campaña no identificada",
        search: "Buscar por mensaje, teléfono o creativo",
        loadMore: "Cargar más",
        stats: {
          total: "Verificados",
          complete: "Completos",
          incomplete: "Incompletos",
          converted: "Convertidos",
        },
        table: {
          contact: "Contacto",
          message: "Mensaje",
          creative: "Creativo",
          phone: "Teléfono",
          status: "Estado Pixel",
          checkedAt: "Verificado en",
        },
        status: {
          complete: "Completo",
          incomplete: "Incompleto",
          notFound: "No encontrado",
          convertedShort: "Convertido",
          converted: "Convertido · €{{value}}",
          purchasesSummary: "{{count}} purchase(s) · Total €{{value}}",
        },
        modal: {
          title: "Enviar conversión al Pixel",
          phone: "Teléfono (automático)",
          value: "Valor de la venta (€)",
          send: "Enviar al Pixel",
          sendUpsell: "Enviar upsell",
          cancel: "Cancelar",
          refresh: "Verificar de nuevo",
          message: "Mensaje rastreado",
          lookupDate: "Fecha del clic",
          leadDate: "Fecha del clic",
          lastPurchase: "Último envío",
          invalidValue: "Ingrese un valor válido.",
          success: "¡Conversión enviada al pixel con éxito!",
          upsellSuccess: "¡Upsell enviado al pixel con éxito!",
          refreshed: "Datos del pixel actualizados.",
        },
        manual: {
          title: "Búsqueda manual",
          date: "Fecha del clic",
          message: "Mensaje exacto",
          messagePlaceholder: "Pegue el mensaje que el cliente envió por WhatsApp",
          search: "Buscar lead",
          phone: "Teléfono del comprador",
          notFound: "No se encontró lead para este mensaje y fecha.",
          clear: "Limpiar",
          messageRequired: "Ingrese el mensaje para buscar.",
          dateRequired: "Ingrese la fecha del clic.",
          phoneRequired: "Ingrese el teléfono del comprador.",
        },
      },
    },
  },
};

export { messages };
